<script>
    import page from 'page'
    import { Notebook } from '../controller.js'

    let name

    function save() {
        let notebook = new Notebook(name)
        notebook.save()
        page(`/notebook/${notebook.id}`)
    }
    function cancel() {
        page(`/`)
    }
</script>

<h1>New Notebook</h1>
<label for="name">Name</label>
<input name="name" bind:value={name}/>

<div id="buttons">
    <button on:click={save}>Save</button>
    <button on:click={cancel}>Cancel</button>
</div>
